import React, { useState } from 'react';
import { ReactComponent as QrcodeIcon } from '../../components/svgs/qrcodeIcon.svg';
import { ReactComponent as HumanIcon } from '../../components/svgs/humanIcon.svg';
import { ReactComponent as PhoneIcon } from '../../components/svgs/phoneIcon.svg';
import { ReactComponent as MessageIcon } from '../../components/svgs/messageIcon.svg';
import { ReactComponent as DateIcon } from '../../components/svgs/dateIcon.svg';
import { ReactComponent as CopyIcon } from '../../components/svgs/copyIcon.svg';
import { ReactComponent as DeleteIcon } from '../../components/svgs/deleteIcon.svg';
import { ReactComponent as MasterCardIcon } from '../../components/svgs/masterCardIcon.svg';
import { ReactComponent as VisaCardIcon } from '../../components/svgs/visaCardIcon.svg';
import ManagerCustomerOrderTab from './ManagerCustomerOrderTab';


const ManagerCustomerDetailsTab = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="customer-details-tab">
      <div className={`tab ${activeTab === 'overview' ? 'active' : ''}`} onClick={() => handleTabClick('overview')}>
        Overview
      </div>
      <div className={`tab ${activeTab === 'orders' ? 'active' : ''}`} onClick={() => handleTabClick('orders')}>
        Orders
      </div>
      <div className={`tab ${activeTab === 'paymentOptions' ? 'active' : ''}`} onClick={() => handleTabClick('paymentOptions')}>
        Payment Options
      </div>
      <div className={`tab ${activeTab === 'invoicing' ? 'active' : ''}`} onClick={() => handleTabClick('invoicing')}>
        Invoicing
      </div>
    <div className='order-details-tab-divider'></div>
      <div className="tab-content">
        {activeTab === 'overview' && (
        <div className="details-content">
            <section className='flex'>
                <section className='flex customer-details-section-container'>
                    <div className='flex gap-10'>
                        <QrcodeIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Customer ID</p>
                            <p className='overview-subtitle'>CUS_i2khfmvg3bz7q5r</p>
                        </div>
                        <div className='copy-icon'>
                        <CopyIcon/>
                        </div>
                        
                    </div>
                    <div className='flex gap-10 '>
                        <HumanIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>First Name</p>
                            <p className='overview-subtitle'>Phoebe</p>
                        </div>
                        <div className='copy-icon-2'>
                        <CopyIcon/>
                        </div>
                    </div>
                    <div className='flex gap-10'>
                        <HumanIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Last Name</p>
                            <p className='overview-subtitle'>Buffay</p>
                        </div>
                        <div className='copy-icon-2'>
                        <CopyIcon/>
                        </div>
                    </div>
                    <div className='flex gap-10'>
                        <PhoneIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Phone Number</p>
                            <p className='overview-subtitle'>+123456789</p>
                        </div>
                        <div className='copy-icon-3'>
                        <CopyIcon/>
                        </div>
                    </div>
                    <div className='flex gap-10'>
                        <MessageIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Emails</p>
                            <p className='overview-subtitle'>phoebe.b@mail.com</p>
                        </div>
                        <div className='copy-icon-4'>
                        <CopyIcon/>
                        </div>
                    </div> 
                    <div className='flex gap-10'>
                        <DateIcon />
                        <div className='flex flex-col gap-3'>
                            <p className='overview-title'>Date Created</p>
                            <p className='overview-subtitle'>Friday, Sep 25, 2023</p>
                        </div>
                        
                    </div>


                </section>
                <section className='flex flex-col pl-10 gap-10 customer-details-notes-section'>
                    <div className='flex flex-col gap-4'>
                        <p className='customer-details-notes-section-title'>Laundry Preference</p>
                        <p className='customer-details-notes-section-subtitle'>Clean efficient installation and stress-free regular maintenance.</p>
                    </div>
                    <div className='flex flex-col gap-4'>
                        <p className='customer-details-notes-section-title'>Laundry Preference</p>
                        <p className='customer-details-notes-section-subtitle'>Clean efficient installation and stress-free regular maintenance.</p>
                    </div>
                </section>
            </section>
            
            
        </div>
          
        )}

        {activeTab === 'orders' && (
          <div className="activity-content">
            <section>
            <ManagerCustomerOrderTab />
            </section>
            

          </div>
        )}
        {activeTab === 'paymentOptions' && (
          <div className="activity-content">
            <section className='flex flex-col gap-4'>
                <p className='saved-cards-text mt-10'>Saved Cards</p>
                <div className='flex flex-col gap-10 mt-10'>
                    <div className='flex gap-20'>
                        <div className='master-card-container'>
                            <MasterCardIcon />
                        </div>
                        
                        <p className='card-no'>**** **** **** 8925</p>
                        <DeleteIcon />
                    </div>
                    <div className='flex gap-20'>
                        <VisaCardIcon />
                        <p className='card-no'>**** **** **** 8925</p>
                        <DeleteIcon />
                    </div>
                    <div className='flex gap-20'>
                        <div className='master-card-container'>
                            <MasterCardIcon />
                        </div>
                        <p className='card-no'>**** **** **** 8925</p>
                        <DeleteIcon />
                    </div>
                   
                </div>
            </section>
            

          </div>
        )}

        {activeTab === 'invoicing' && (
            <div className="activity-content flex flex-col customer-invoicing-section">
                <section>
                    <p className='customer-invoicing-title'>Invoice Settings</p>
                    <p className='customer-invoicing-subtitle'>Manage invoice settings for this user</p>
                </section>
                <section>
                    <p className='customer-invoicing-billing-title'>Billing Frequency</p>
                    <select className='mt-2 choose-payment-dropdown'>
                        <option value="option1">Pre order</option>
                        <option value="option2">Per month</option>
                       
                    </select>
                </section>

                <section>
                    <p className='customer-invoicing-billing-title'>Payment Terms</p>
                    <select className='mt-2 choose-payment-dropdown'>
                        <option value="option1">On completion</option>
                        <option value="option2">Next 30days</option>
                        
                    </select>
                </section>
            </div>
        )}

      </div>
    </div>
  );
};

export default ManagerCustomerDetailsTab;
